import type { Control } from 'react-hook-form';
import { TextField } from 'ui';

import type { AddConfigValueType } from '../../../models';
import type { RemoteConfigFormValues } from '../../RemoteConfig';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useState } from 'react';

type RemoteConfigPasswordFieldProps = {
  control: Control<RemoteConfigFormValues>;
  name: string;
  value: AddConfigValueType;
  disabled: boolean;
  type: string;
};

export function RemoteConfigPasswordField({
  type,
  value,
  name,
  control,
  disabled,
}: RemoteConfigPasswordFieldProps) {
  const [togglePassword, setTogglePassword] = useState(false);

  return (
    <TextField
      onClickInputIcon={() => setTogglePassword((isShow) => !isShow)}
      defaultValue={value}
      name={name}
      rules={{
        required: 'Field is required',
      }}
      showErrorIcon={false}
      control={control}
      disabled={disabled}
      type={togglePassword ? 'text' : 'password'}
      icon={
        togglePassword ? (
          <AiOutlineEye size={20} />
        ) : (
          <AiOutlineEyeInvisible size={20} />
        )
      }
    />
  );
}
